// extracted by mini-css-extract-plugin
var _1 = "InstanceSettings_cell__iUOxn";
var _2 = "InstanceSettings_container__QX6lj";
export { _1 as "cell", _2 as "container" }
